import styles from './style.module.css';

import { useEffect, useId, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Clipboard } from '../Clipboard';
import { ShareButton } from '../ShareButtons';
import { ICardReveal, ISlideOptions } from './interfaces';

import moment from 'moment';
import * as routes from '../../constants/Routes';
import { getYouTubeEmbed } from '../../utils/getYouTubeEmbed';
import { Button } from '../Button';

function CardReveal({
  title,
  frame,
  image,
  action,
  idProps,
  ctaText,
  client,
  player,
  isInteract,
  actionImagesBase64,
}: ICardReveal) {
  const navigate = useNavigate();
  const [isOpenReveal, setIsOpenReveal] = useState<boolean>();
  const [dataSlideVideo, setDataSlideVideo] = useState<Array<object>>([]);
  const [dataSlideImages, setDataSlideImages] = useState<Array<object>>([]);
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  const id = useId();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const dataContentActionVideo: Array<object> = [];
    const dataContentActionImages: Array<object> = [];

    if (action.images && action.images.length >= 1 && action.videoURL !== '') {
      dataContentActionVideo.push({
        urlVideo: getYouTubeEmbed(action.videoURL),
      });

      dataContentActionImages.push({
        urlImages: action.images,
      });

      setDataSlideVideo(dataContentActionVideo);
      setDataSlideImages(dataContentActionImages);
    }
  }, []);

  function getUniqueId() {
    return id.replace(/:/g, '');
  }

  function renderImageCardBanner(image: any) {
    if (!image || image === '') return null;
    return <img src={image} alt="imagem" />;
  }

  function renderFrameCardBanner(frame: any) {
    if (!frame || !getYouTubeEmbed(frame)) return null;
    if (!isVisible) {
      return (
        <div
          className="ratio ratio-16x9"
          style={{ background: '#f0f0f0' }}
        ></div>
      );
    }
    return (
      <div className="ratio ratio-16x9">
        <iframe
          src={getYouTubeEmbed(frame, {
            autoplay: false,
            mute: false,
            controls: true,
          })}
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    );
  }

  function hasValidCarousel(): boolean {
    return (
      Array.isArray(dataSlideVideo) &&
      dataSlideVideo.length > 0 &&
      Array.isArray(dataSlideImages) &&
      dataSlideImages.length > 0
    );
  }

  const onHandleActionDetails = (action: any) => {
    if (action?.actionType === 'informational') {
      window.open(action.pageURL, '_blank');
    } else {
      navigate(`${routes.ACTION_DETAILS}/${action.id}`);
    }
  };

  function handleShareReveal() {
    setIsOpenReveal(!isOpenReveal);
  }

  return (
    <div
      ref={cardRef}
      className="col-12 col-sm-12 col-md-6 col-lg-4"
      key={idProps}
      id={idProps}
    >
      <div className={styles.cardReveal}>
        <div className={styles.cardBanner}>
          {frame && getYouTubeEmbed(frame) ? (
            renderFrameCardBanner(frame)
          ) : image && image !== '' ? (
            renderImageCardBanner(image)
          ) : hasValidCarousel() ? (
            <>
              <div
                id={getUniqueId()}
                key={idProps}
                className="carousel slide "
                data-bs-ride="carousel"
              >
                <div className="carousel-inner" id="cards-slide-wide">
                  {dataSlideImages.map((item: ISlideOptions) => {
                    return (
                      item.urlImages &&
                      item.urlImages.map((image, index) => {
                        return (
                          <div className={`carousel-item active`} key={index}>
                            <img
                              src={image.url}
                              className="d-block w-100"
                              alt={''}
                            />
                          </div>
                        );
                      })
                    );
                  })}
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target={`#${getUniqueId()}`}
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target={`#${getUniqueId()}`}
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </>
          ) : null}
        </div>
        <div className={`${styles.cardTitle} text-truncate p-4`}>
          <span key={title}>{title}</span>
        </div>
        {isInteract && (
          <div className={`${styles.cardContent} px-4`}>
            {/* Publicações quiz */}
            {action.actionType === 'quiz' && (
              <div className={`${styles.details}`}>
                <span className={styles.badge}>
                  Questões: {action.questions && action.questions.length}
                </span>
                <span className={styles.badge}>
                  {(action.quizDetails?.quizType !== 'performance' &&
                    action.quizChoice === 'true') ||
                  (action.quizDetails?.quizType === 'performance' &&
                    action.quizDetails?.amountOfRetries === 1)
                    ? 'Única'
                    : 'Múltipla'}
                </span>
                <span className={styles.badge}>
                  Até: {action && moment(action.endDate).format('DD/MM/YYYY')}
                </span>
              </div>
            )}

            {/* Publicações NPS */}
            {action.actionType === 'researchAward' && (
              <div className={`${styles.details}`}>
                <span className={styles.badge}>{`${action.actionTitle}`}</span>
              </div>
            )}

            {/* Publicações que não são quiz ou nps e estão com compartilhamento ativado para MD */}
            {action.actionType !== 'quiz' &&
              action.actionType !== 'researchAward' &&
              action.shareButtonsVisible &&
              action.conversionType !== 'autoindicate' &&
              client &&
              client.clientUrl === 'md' && (
                <Clipboard actionId={action.id} shareUrl={action.shareUrl} />
              )}

            {/* Publicações que não são quiz ou nps geral */}
            {action.actionType !== 'quiz' &&
              action.actionType !== 'researchAward' &&
              action.conversionType !== 'autoindicate' &&
              client &&
              client.clientUrl !== 'md' && (
                <Clipboard actionId={action.id} shareUrl={action.shareUrl} />
              )}

            {/* Publicações que não são quiz ou nps geral */}
            {action.actionType !== 'quiz' &&
              action.actionType !== 'researchAward' &&
              action.conversionType === 'autoindicate' &&
              client &&
              client.clientUrl !== 'md' && (
                <div className={`${styles.details}`}>
                  <span
                    className={styles.badge}
                  >{`${action.actionTitle}`}</span>
                </div>
              )}

            {/* Publicações que não são quiz ou nps geral */}
            {action.actionType !== 'quiz' &&
              action.actionType !== 'researchAward' &&
              action.conversionType === 'autoindicate' &&
              client &&
              client.clientUrl === 'md' && (
                <div className={`${styles.details}`}>
                  <span
                    className={styles.badge}
                  >{`${action.actionTitle}`}</span>
                </div>
              )}

            {/* Publicações que não são quiz ou nps e NÃO estão com compartilhamento ativado para MD */}
            {action.actionType !== 'quiz' &&
              action.actionType !== 'researchAward' &&
              !action.shareButtonsVisible &&
              client &&
              client.clientUrl === 'md' && (
                <div className={`${styles.details}`}>
                  <span
                    className={styles.badge}
                  >{`${action.actionTitle}`}</span>
                </div>
              )}
          </div>
        )}
        <div className={`${styles.cardAction} mt-4`}>
          <button
            className={
              action.actionType === 'quiz' ||
              action.actionType === 'researchAward' ||
              action.conversionType === 'autoindicate' ||
              (client &&
                client.clientUrl === 'md' &&
                !action.shareButtonsVisible)
                ? styles.cta
                : action.conversionType === 'autoindicate'
                  ? styles.cta
                  : ''
            }
            onClick={() => {
              if (!isInteract) {
                navigate(routes.REGISTER_DETAILS);
              } else {
                onHandleActionDetails(action);
              }
            }}
          >
            <i className="material-icons-outlined mx-2">add</i>
            {action.conversionType !== 'autoindicate' && (
              <span>{ctaText ? ctaText : 'Mais detalhes'}</span>
            )}
            {action.conversionType === 'autoindicate' && (
              <span>
                {client.clientUrl === 'primeclinic'
                  ? 'Marcar agora'
                  : ctaText
                    ? ctaText
                    : player && player.regional === 'sim'
                      ? 'Registrar Lead'
                      : 'Indicar agora'}
              </span>
            )}
          </button>

          {/* verificação para MD para mostrar ou não o compartilhamento */}
          {action.actionType !== 'quiz' &&
            action.actionType !== 'researchAward' &&
            action.shareButtonsVisible &&
            action.conversionType !== 'autoindicate' &&
            client &&
            client.clientUrl === 'md' && (
              <>
                <button
                  className={styles.cta}
                  onClick={() => {
                    if (!isInteract) {
                      navigate(routes.REGISTER_DETAILS);
                    } else {
                      handleShareReveal();
                    }
                  }}
                >
                  <i className="material-icons-outlined mx-2">share</i>
                  <span>Compartilhe</span>
                </button>
              </>
            )}

          {/* verificação para GERAL para mostrar o compartilhamento */}
          {action.actionType !== 'quiz' &&
            action.actionType !== 'researchAward' &&
            action.conversionType !== 'autoindicate' &&
            client &&
            client.clientUrl !== 'md' && (
              <>
                <button
                  className={styles.cta}
                  onClick={() => {
                    if (!isInteract) {
                      navigate(routes.REGISTER_DETAILS);
                    } else {
                      handleShareReveal();
                    }
                  }}
                >
                  <i className="material-icons-outlined mx-2">share</i>
                  <span>Compartilhe</span>
                </button>
              </>
            )}
        </div>
        <div className={styles.revealWrapper}>
          <div
            className={`${styles.reveal} ${isOpenReveal ? styles.open : ''}`}
          >
            <div className={`${styles.content} p-4`}>
              <div className={styles.topReveal}>
                <span>Compartilhe</span>
                <button onClick={handleShareReveal}>
                  <i className="material-icons-outlined">close</i>
                </button>
              </div>
              <div className="container">
                <span className="">Compartilhe rapidamente via</span>
                <div className="my-3">
                  <ShareButton
                    action={action}
                    posterDownload
                    actionImagesBase64={actionImagesBase64}
                  />
                </div>
                <span>Ou copie o link</span>
                <div className="mt-3">
                  <Clipboard shareUrl={action.shareUrl} actionId={action.id} />
                </div>
                {action && action.isAutoIndicateEnabled === 'true' && (
                  <>
                    <div className="mt-3">
                      <Link
                        to={`${routes.ACTION_DETAILS}/${action && action.id}?auto=true`}
                      >
                        <div className="d-grid">
                          <Button
                            text={
                              player && player.regional === 'sim'
                                ? 'Registrar Lead'
                                : 'Indicar Agora'
                            }
                            color="primary"
                            icon="new_releases"
                          />
                        </div>
                      </Link>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { CardReveal };
